import MaterialTable from "material-table";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { CommonUrl, NONCE, TIME_STAMP,logoutMsg } from "../common-url/CommonUrl";
import { makeStyles } from "@material-ui/core/styles";
import { Popover, Typography } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import { shallowEqual, useSelector } from "react-redux";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

// import MenuBookTwoToneIcon from '@material-ui/icons/MenuBookTwoTone';

const useStyles = makeStyles(theme => ({
  root: {
    /*"& .MuiPaper-root": {
      borderBottom: "none",
      backgroundColor:"transparent",
      boxShadow:"none"
    },*/
    "& .MuiInput-underline:before":{
      borderBottom: 0,
    },
    "& .MuiInput-underline:after":{
      borderBottom: 0,
    },
    "& .MuiInput-root":{
      borderBottom: 0,
    },
    "&:last-child td": {
      // borderBottom: 0,
    },
  },
  typography: {
    padding: theme.spacing(3),
    boxShadow: theme.shadows[10],
    background: "linear-gradient(to bottom, #3699FF, #1BC5BD)"
  }
}));

export default function SubOrdinateUser(selectedSubUserData) {
  const [subUser, setSubUser] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const classes = useStyles();
  var { id } = useParams();

  const history = useHistory();

  const columns = [
    { title: "Full Name", field: "vFullName" },
    { title: "User Name", field: "vUserName" },
    { title: "Email", field: "vEmail" },
    { title: "Phone No", field: "bPhoneNumber" },
    {
      title: "Master User",
      field: "iParentUserId",
      render: rowData => <span>{rowData.iParentUserId.vFullName}</span>,
      customFilterAndSearch: (term, rowData) =>
        term == rowData.iParentUserId.vFullName
    }
  ];
  // ------------------------------------------------------
  // get the master user list on initial loading
  // ------------------------------------------------------

  const selectedSubUserOfMasterUser = selectedSubUserData.location.state;
  const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);
  const myTextIcon = React.useRef(null);

  useEffect(() => {
    myTextIcon.current.parentNode.parentNode.classList.remove('MuiIconButton-root');
    if (id) {
      getSelectedSubUsers();
      return () => {
        id = null;
      };
    } else {
      fetchSubOrdinateUser();
    }
  }, []);

  const getSelectedSubUsers = async () => {
    await fetch(CommonUrl.masterUserBaseUrl + "/sub-users", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        _id: id
      }
    })
      .then(response => response.json())
      .then(response => {
          setSubUser(response.data);
      });
  };

  const fetchSubOrdinateUser = async () => {
    history.push("/subordinate-user");
    await fetch(CommonUrl.subUserBaseUrl + "/get-all-sub-users", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.code == 401) {
          history.push("/logout");
          toast.info(logoutMsg,{autoClose:5000})

        } else {
        setSubUser(response.data);
      }
      });
  };

  // ------------------------------------------------------
  // selected row details show in popup
  // ------------------------------------------------------

  const showDetails = selectedRow => {
    setSelectedUser(selectedRow);
    handleOpen();
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="pb-5"></div>
      <div className="App">
        {/* user pop-up start */}
        <Popover
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "center",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "center"
          }}
        >
          <div className={classes.typography}>
            <Typography className="text-white">
              Id : <h5 className="font-weight-bold"> {selectedUser._id} </h5>
            </Typography>
            <Typography className="text-white">
              Full Name :{" "}
              <h5 className="font-weight-bold"> {selectedUser.vFullName} </h5>
            </Typography>
            <Typography className="text-white">
              Username :{" "}
              <h5 className="font-weight-bold"> {selectedUser.vUserName} </h5>
            </Typography>
            <Typography className="text-white">
              Email :{" "}
              <h5 className="font-weight-bold"> {selectedUser.vEmail} </h5>
            </Typography>
            <Typography className="text-white">
              Phonen Number :{" "}
              <h5 className="font-weight-bold">
                {" "}
                {selectedUser.bPhoneNumber}{" "}
              </h5>
            </Typography>
            <Typography className="text-white">
              Created At :{" "}
              <h5 className="font-weight-bold">
                {" "}
                {moment(selectedUser.iCreatedAt * 1000).format(
                  "MMMM Do YYYY, h:mm:ss a"
                )}
              </h5>
            </Typography>
            <Typography className="text-white">
              Updated At :{" "}
              <h5 className="font-weight-bold">
                {" "}
                {moment(selectedUser.iUpdatedAt * 1000).format(
                  "MMMM Do YYYY, h:mm:ss a"
                )}
              </h5>
            </Typography>
          </div>
        </Popover>
        {/* user pop-up end */}
        <div className=" ">
          {/* data table start */}
          <div className={classes.root}>
            <MaterialTable
              style={{
                paddingInline: "30px",
                paddingTop: "10px",
                borderBottom: "none"
              }}
              title="Sub-ordinate user List"
              data={subUser}
              columns={columns}
              options={{
                filtering: false,
                actionsColumnIndex: -1,
                addRowPosition: "first",
                emptyRowsWhenPaging: false, // To avoid of having empty rows
                headerStyle: {
                  fontWeight: 600,
                  color: "#b5b5c3",
                  fontSize: ".9rem",
                  textTransform: "uppercase",
                  letterSpacing: ".1rem",
                },
                searchFieldStyle:{
                  padding:"4px",
                  backgroundClip: "padding-box",
                  border: "1px solid #ced4da",
                  borderRadius: "0.30rem"
                }
              }}
              actions={[
                {
                  // icon: RefreshIcon,
                  icon:()=><div className={id?"":"d-none"} ref={myTextIcon}><button className="btn  btn-light-primary mx-6"><RefreshIcon/></button></div> ,
                  tooltip: "All Subordinate User",
                  isFreeAction: true,
                  onClick: event => fetchSubOrdinateUser()
                }
              ]}
              onRowClick={(evt, selectedRow) => {
                showDetails(selectedRow);
              }}
            />
          </div>
          {/* data table end */}
        </div>
      </div>
    </>
  );
}
